/* eslint-disable max-len */
/* eslint-disable vue/max-len */

import { create } from '@bufbuild/protobuf';

import * as pbm from '@/grpc-gen/feedback_settings_pb';
import * as pbs from '@/grpc-gen/feedback_service_pb';

export interface FeedbackSettingsMapping {
}

export default class FeedbackSettings {
  id: number = 0;

  enabled: boolean = false;

  useBreakdown?: boolean;

  noRuleError: boolean = false;

  static fromGrpcResponse(r: pbs.FeedbackSettingsResponse, m?: FeedbackSettingsMapping): FeedbackSettings {
    return FeedbackSettings.fromGrpcModel(r.settings, m);
  }

  static fromGrpcModel(o?: pbm.FeedbackSettings, m?: FeedbackSettingsMapping): FeedbackSettings {
    const p = new FeedbackSettings();

    p.enabled = o?.enabled ?? false;
    p.noRuleError = o?.noRuleError ?? false;

    if (o?.useBreakdown !== undefined) p.useBreakdown = o.useBreakdown;

    return p;
  }

  toGrpcModel(): pbm.FeedbackSettings {
    return create(pbm.FeedbackSettingsSchema, {
      enabled: this.enabled ?? false,
      useBreakdown: this.useBreakdown,
      noRuleError: this.noRuleError ?? false,
    });
  }
}
